<template>
  <div class="webFooter">
    <div class="webFooterBox">
      <div class="footer_01">
        <p>地址：成都市一环路南一段24号</p>
        <p>办公电话：028-85464822 传真：028-85503835</p>
        <p>招生咨询 成教、自考：028-86089099 028-85401327</p>
      </div>
      <div class="footer_02">
        <p>
          <a
            href="http://cce.scu.edu.cn/mana/login.jsp"
            target="blank"
            style="color: #999;text-decoration: none;"
            >Copyright©2002-2018四川大学继续教育学院版权所有</a
          >
        </p>
        <p>ICP备案：蜀icp备05006382号-3</p>
      </div>
      <div class="footer_03">
        <div class="line_01">
          <div>
            <span
              ><a href="http://www.scu.edu.cn" target="_blank" title="四川大学"
                >>&nbsp;四川大学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a
              ></span
            >
          </div>
          <div>
            <span
              ><a
                href="http://cce.scu.edu.cn:80/mana/view/home/employeeBoard.do"
                title="职工留言"
                target="_blank"
                >>&nbsp;职工留言</a
              ></span
            >
          </div>
        </div>
        <div class="line_02">
          <div>
            <span
              ><a
                href="javascript:alert('请发送邮件到：ccesj@scu.edu.cn\n联系电话：028-85464822')"
                >>&nbsp;书记信箱&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a
              ></span
            >
          </div>
          <div>
            <span
              ><a
                href="javascript:alert('请发送邮件到：cceyz@scu.edu.cn\n联系电话：028-85464822');"
                >>&nbsp;院长信箱</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "webFooter",
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.webFooter {
  width: 100%;
  height: 120px;
  background-color: #333;
  .webFooterBox {
    width: 1200px;
    height: 100%;
    font-size: 14px;
    color: #999;
    line-height: 25px;
    margin: 0 auto;
    & > div {
      float: left;
    }
    .footer_01 {
      width: 602px;
      height: 70px;
      padding-top: 20px;
      p {
        margin: 0;
        padding: 0;
      }
    }
    .footer_02 {
      width: 430px;
      height: 70px;
      padding-top: 20px;
      p {
        margin: 0;
        padding: 0;
      }
    }
    .footer_03 {
      width: 168px;
      height: 56px;
      padding-top: 20px;
      margin-top: 15px;
      .line_01 {
        div {
          float: left;
          span {
            a:link,
            a:hover,
            a:active,
            a:visited {
              color: #999;
              text-decoration: none;
            }
          }
        }
      }
      .line_02 {
        div {
          float: left;
          span {
            a:link,
            a:hover,
            a:active,
            a:visited {
              color: #999;
              text-decoration: none;
            }
          }
        }
      }
    }
  }
}
</style>
